import React from 'react'
import { isMobile } from '../../helpers/mobileresize/Mobileresize'
import WebNavbar from './web/index'
import MobileNavbar from './android/index'

const index = () =>{
    if(isMobile){
        return(
            <div>
                <MobileNavbar />
            </div>
        )
    }else{
        return(
            <div>
                <WebNavbar />
            </div>
        )
    }
}

export default index